var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgNotSureEyewearPrescriptionIcon = function SvgNotSureEyewearPrescriptionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#notSureEyewearPrescriptionIcon_svg__clip0_8227_86481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 9.647V9.5c0-4.963-3.813-9-8.5-9C7.813.5 4 4.537 4 9.5v.147A3.5 3.5 0 001.5 13v2a3.5 3.5 0 107 0v-2A3.5 3.5 0 006 9.647V9.5c0-3.86 2.916-7 6.5-7s6.5 3.14 6.5 7v.147A3.5 3.5 0 0016.5 13v2a3.5 3.5 0 002.5 3.353v.188a2.962 2.962 0 01-2.959 2.959h-1.819a1.99 1.99 0 00-1.722-1 2 2 0 000 4 1.99 1.99 0 001.723-1h1.818A4.964 4.964 0 0021 18.541v-.188A3.5 3.5 0 0023.5 15v-2A3.5 3.5 0 0021 9.647zM6.5 13v2c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5v-2c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5zm15 2c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5v-2c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5v2z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "notSureEyewearPrescriptionIcon_svg__clip0_8227_86481"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5 .5)",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgNotSureEyewearPrescriptionIcon;